import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionText } from '../../../../../components/SectionText'

interface PostcareProps {
    className?: string
}

export const Postcare: React.FC<PostcareProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <>
            <div className={`${className} w-full bg-primary-green min-h-[500px] h-auto flex items-center justify-center`}>
                <div className="w-1/2 h-full text-white flex flex-col items-center justify-center sm:w-full sm:py-5 sm:px-5">
                    <SectionText
                        className="max-h-full flex flex-col justify-between"
                        title={t('AmbulantOperation.Postcare.post_op_title')}
                        hrLineColor="bg-primary-blue">
                        <ul className="list-disc pl-5 flex flex-col min-h-[200px] py-3">
                            <li>{t('AmbulantOperation.Postcare.post_op_content_1')}</li>
                            <li className="pt-4">{t('AmbulantOperation.Postcare.post_op_content_2')}</li>
                        </ul>
                    </SectionText>
                </div>
            </div>
            <div className={`${className} w-full bg-white min-h-[400px] h-auto flex items-center justify-center`}>
                <div className="w-1/2 min-h-[200px] h-auto text-black flex flex-col justify-between sm:w-full sm:py-5 sm:px-5">
                    <div>{t('AmbulantOperation.Postcare.pain_management')}</div>
                    <div>{t('AmbulantOperation.Postcare.evening_visit')}</div>
                    <div>{t('AmbulantOperation.Postcare.wound_care')}</div>
                </div>
            </div>
        </>
    )
}
